"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var globalContext_1 = require("../../globalContext");
var mobx_react_1 = require("mobx-react");
function setPropAccessors(props, selector) {
    var newProps = {};
    Object.keys(props).forEach(function (key) {
        newProps[key] = props[key];
    });
    Object.keys(selector).forEach(function (key) {
        var getter = selector[key];
        if (typeof newProps[key] === typeof undefined) {
            Object.defineProperty(newProps, key, {
                enumerable: true,
                get: function () { return getter.call(null, newProps); },
            });
        }
    });
    return newProps;
}
function createNewConstructor(original, selector) {
    if (!selector) {
        return original;
    }
    return (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_1.prototype.render = function () {
            return React.createElement(original, setPropAccessors(this.props, selector));
        };
        return class_1;
    }(React.Component));
}
function createNewFunctionalComponent(original, selector) {
    if (!selector) {
        return original;
    }
    return function (props) {
        var newProps = setPropAccessors(props, selector);
        return original.call(original, newProps);
    };
}
function isReactComponent(target) {
    return target && target.prototype && target.prototype.isReactComponent;
}
function isFunction(target) {
    return target instanceof Function;
}
function reactive(selectorOrComponentClass) {
    if (isReactComponent(selectorOrComponentClass)) {
        var componentClass = selectorOrComponentClass;
        return mobx_react_1.observer(componentClass);
    }
    return function (target) {
        if (globalContext_1.getGlobalContext().legacyTestMode) {
            if (isReactComponent(target)) {
                return mobx_react_1.observer(target);
            }
            else if (isFunction(target)) {
                return mobx_react_1.observer(target);
            }
            return target;
        }
        var newComponent;
        if (isReactComponent(target)) {
            newComponent = mobx_react_1.observer(createNewConstructor(mobx_react_1.observer(target), selectorOrComponentClass));
            newComponent.nonReactiveComponent = target;
            return newComponent;
        }
        else if (isFunction(target)) {
            newComponent = mobx_react_1.observer(createNewFunctionalComponent(target, selectorOrComponentClass));
            newComponent.nonReactiveStatelessComponent = target;
            return newComponent;
        }
        return newComponent;
    };
}
exports.default = reactive;
